import { Record } from 'immutable';
export default class GoogleAuthQRCode extends Record({
  url: undefined,
  manualCode: undefined,
  qrCodeData: undefined
}) {}